import React, { useState } from 'react';
import {
  IconButton,
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryAction,
  Typography,
  Tooltip,
  Box,
} from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { styled } from '@mui/material/styles';
import { ClipLoader } from 'react-spinners';

const ShortInfoMenuPopup = ({ features, onInfoMenuClick }) => {
  const [loadingState, setLoadingState] = useState({});
  const transformString = (label) => {
    let cleanedString = label.replace(/[\d._]+/g, ' ');

    return cleanedString
      .split(' ')
      .filter((word) => word)
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const handleClick = async (item) => {
    const layerNameWithoudId = item.id.split('.')[0];
    const layerName = layerNameWithoudId
    setLoadingState((prevStates) => ({
      ...prevStates,
      [item.id]: true,
    }));
  
    try {
      await onInfoMenuClick(item.id, layerName);
    } finally {
      setLoadingState((prevStates) => ({
        ...prevStates,
        [item.id]: false,
      }));
    }
  };

  return (
    <>
      <Box sx={{ maxHeight: '280px', overflowY: 'auto' }}>
        <List disablePadding>
          {features.map((item, index) => (
            <StyledListItem key={index}>
              <ListItemText
                primary={
                  <Typography
                    variant="body1"
                    color="#676767"
                    sx={{
                      fontSize: '15px',
                      fontWeight: 500,
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {transformString(String(item.id))}
                  </Typography>
                }
                secondary={
                  <Typography
                    variant="body2"
                    color="#7e7e7e"
                    sx={{
                      fontSize: '14px',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    {item.properties.oznaka ? item.properties.oznaka : ''}
                  </Typography>
                }
              />
              {
                loadingState[item.id] ? 
                <div style={{ paddingLeft: '10px', paddingTop: '4px' }}>
                  <ClipLoader
                    color={"#21538f"}
                    loading={true}
                    size={25}
                    data-testid="loader"
                  />
                </div>
                :           
                <ListItemSecondaryAction>
                  <Tooltip title="Prikaži info tabelu" arrow>
                    <IconButton edge="end" aria-label="info" onClick={() => handleClick(item)}>
                      <InfoIcon sx={{ color: "#21538f" }} />
                    </IconButton>
                  </Tooltip>
                </ListItemSecondaryAction>
              }
            </StyledListItem>
          ))}
        </List>
      </Box>
    </>
  );
};
export default ShortInfoMenuPopup;

const StyledListItem = styled(ListItem)(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.spacing(1),
  marginBottom: theme.spacing(0.7),
  boxShadow: theme.shadows[1],
  height: '50px',
  transition: 'background-color 0.3s, box-shadow 0.3s',
  '&:hover': {
    backgroundColor: theme.palette.grey[200],
    boxShadow: theme.shadows[2],
  },
}));
